// i18n keys of the multi-tenant work package "firmcontact" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
// {{site}} = the firm's website host from Admin → Companies (utils/firmContact); the *_plain twin is used while none is set.
export const en: Record<string, string> = {
  fc_wf_sync: 'Changes sync instantly to the client’s page ({{site}}).',
  fc_wf_sync_plain: 'Changes sync instantly to the client’s page.',
  fc_poa_matching_sub: 'Checking the quote link in the comments against {{site}}',
  fc_poa_matching_sub_plain: 'Checking the quote link in the comments against the public site',
  fc_lr_draft_no_fee: 'No legal fee to bill yet — this registration is still on "review" on {{site}}.',
  fc_lr_draft_no_fee_plain: 'No legal fee to bill yet — this registration is still on "review" on the public site.',
  fc_lr_open_full: 'Open / manage on {{site}} (needs a login there)',
  fc_lr_open_full_plain: 'Open / manage on the public site (needs a login there)',
  fc_lr_readonly: 'Read-only — managed on {{site}}',
  fc_lr_readonly_plain: 'Read-only — managed on the public site',
  fc_client_role_hint: 'This is a client-portal login ({{site}}). Its role and modules are managed on the Client Portal tab, not here.',
  fc_client_role_hint_plain: 'This is a client-portal login. Its role and modules are managed on the Client Portal tab, not here.',
  fc_no_market_cities: 'No market city is set — add one in Admin → Companies (a firm’s market region, or the AI Marketing cities).',
  fc_market_title: 'Market region & lead sites',
  fc_market_hint: 'Where this firm works. AI prompts describe the firm with it (“a law firm on <region>, <country>”), and AI Marketing starts from it while no city list is saved. The phone, email and website above are what reports print and what the firm’s public links are built on.',
  fc_market_region: 'Town / area',
  fc_market_region_hint: 'Empty = no place is named.',
  fc_lead_sites: 'Other websites that send leads',
  fc_lead_sites_hint: 'Contact forms on these sites (and on the website above) file their enquiries as this firm’s leads. Comma-separated, e.g. example.com.',
  fc_cities_title: 'AI Marketing cities',
  fc_cities_hint: 'The cities AI Marketing prospects, in order — the first is the default. Each sub-area is searched in turn; a city with no sub-areas is searched as a whole.',
  fc_cities_from_firms: 'No list saved — using the firms’ market regions: {{cities}}.',
  fc_cities_none: 'No list saved and no firm has a market region — AI Marketing has no city to search yet.',
  fc_city_default: 'City (default)',
  fc_city: 'City',
  fc_city_areas: 'Sub-areas (one per line)',
  fc_city_areas_ph: 'Empty = the whole city',
  fc_city_add: 'Add city',
  fc_am_subtitle: '{{country}} business directory ({{cities}}) — discovered & editable',
  fc_am_subtitle_nocountry: 'Business directory ({{cities}}) — discovered & editable',
  fc_social_unset: 'No Social Poster address is set for this installation — it is REACT_APP_SOCIAL_POSTER_URL in the build settings (.env.production).',
};
export const zh: Record<string, string> = {
  fc_wf_sync: '改动实时同步到客户页面({{site}})。',
  fc_wf_sync_plain: '改动实时同步到客户页面。',
  fc_poa_matching_sub: '正在用评论里的报价链接匹配 {{site}}',
  fc_poa_matching_sub_plain: '正在用评论里的报价链接匹配公开网站',
  fc_lr_draft_no_fee: '还没有律师费可开——这条登记在 {{site}} 上仍是“待核”。',
  fc_lr_draft_no_fee_plain: '还没有律师费可开——这条登记在公开网站上仍是“待核”。',
  fc_lr_open_full: '在 {{site}} 打开/管理(需另有该站登录)',
  fc_lr_open_full_plain: '在公开网站打开/管理(需另有该站登录)',
  fc_lr_readonly: '只读——在 {{site}} 上管理',
  fc_lr_readonly_plain: '只读——在公开网站上管理',
  fc_client_role_hint: '这是客户门户登录({{site}})。它的角色与模块在 Client Portal 页签里管理,不在这里改。',
  fc_client_role_hint_plain: '这是客户门户登录。它的角色与模块在 Client Portal 页签里管理,不在这里改。',
  fc_no_market_cities: '还没有设置市场城市——请在 Admin → Companies 填写(事务所的市场地域,或 AI Marketing 城市)。',
  fc_market_title: '市场地域与线索网站',
  fc_market_hint: '本所所在/服务的地方。AI 提示词用它描述本所(“位于 <地区>, <国家> 的律所”);没有保存城市清单时,AI Marketing 也从这里开始。上面的电话、邮箱、官网就是报告上印的、以及本所对外链接所用的。',
  fc_market_region: '城市/地区',
  fc_market_region_hint: '留空 = 不写地点。',
  fc_lead_sites: '其他会发来线索的网站',
  fc_lead_sites_hint: '这些网站(以及上面的官网)的留言表单,询盘会记为本所的线索。用逗号分隔,例如 example.com。',
  fc_cities_title: 'AI Marketing 城市',
  fc_cities_hint: 'AI Marketing 拓客的城市,按顺序——第一个是默认。每个片区依次搜索;没有片区的城市整体搜索。',
  fc_cities_from_firms: '未保存清单——正在使用各事务所的市场地域:{{cities}}。',
  fc_cities_none: '未保存清单,也没有任何事务所填写市场地域——AI Marketing 暂时没有可搜索的城市。',
  fc_city_default: '城市(默认)',
  fc_city: '城市',
  fc_city_areas: '片区(每行一个)',
  fc_city_areas_ph: '留空 = 整个城市',
  fc_city_add: '添加城市',
  fc_am_subtitle: '{{country}}企业名录（{{cities}}）—— AI 探索 + 可编辑',
  fc_am_subtitle_nocountry: '企业名录（{{cities}}）—— AI 探索 + 可编辑',
  fc_social_unset: '本安装尚未设置 Social Poster 的地址 —— 在构建设置 (.env.production) 的 REACT_APP_SOCIAL_POSTER_URL 中填写。',
};
export const th: Record<string, string> = {
  fc_wf_sync: 'การเปลี่ยนแปลงซิงก์ไปที่หน้าลูกค้าทันที ({{site}})',
  fc_wf_sync_plain: 'การเปลี่ยนแปลงซิงก์ไปที่หน้าลูกค้าทันที',
  fc_poa_matching_sub: 'กำลังตรวจลิงก์ใบเสนอราคาในหมายเหตุกับ {{site}}',
  fc_poa_matching_sub_plain: 'กำลังตรวจลิงก์ใบเสนอราคาในหมายเหตุกับเว็บไซต์สาธารณะ',
  fc_lr_draft_no_fee: 'ยังไม่มีค่าบริการทางกฎหมายให้เรียกเก็บ — รายการนี้ยังเป็น "รอตรวจ" ที่ {{site}}',
  fc_lr_draft_no_fee_plain: 'ยังไม่มีค่าบริการทางกฎหมายให้เรียกเก็บ — รายการนี้ยังเป็น "รอตรวจ" ที่เว็บไซต์สาธารณะ',
  fc_lr_open_full: 'เปิด/จัดการที่ {{site}} (ต้องล็อกอินเว็บนั้น)',
  fc_lr_open_full_plain: 'เปิด/จัดการที่เว็บไซต์สาธารณะ (ต้องล็อกอินเว็บนั้น)',
  fc_lr_readonly: 'อ่านได้เท่านั้น — จัดการที่ {{site}}',
  fc_lr_readonly_plain: 'อ่านได้เท่านั้น — จัดการที่เว็บไซต์สาธารณะ',
  fc_client_role_hint: 'นี่คือบัญชีพอร์ทัลลูกค้า จัดการได้ที่แท็บ Client Portal',
  fc_client_role_hint_plain: 'นี่คือบัญชีพอร์ทัลลูกค้า จัดการได้ที่แท็บ Client Portal',
  fc_no_market_cities: 'ยังไม่ได้ตั้งเมืองเป้าหมาย — เพิ่มได้ที่ Admin → Companies (พื้นที่ตลาดของสำนักงาน หรือเมืองของ AI Marketing)',
  fc_market_title: 'พื้นที่ตลาดและเว็บไซต์ลูกค้าเป้าหมาย',
  fc_market_hint: 'พื้นที่ที่สำนักงานนี้ให้บริการ ข้อความสั่ง AI ใช้บรรยายสำนักงาน ("สำนักงานกฎหมายที่ <พื้นที่>, <ประเทศ>") และ AI Marketing เริ่มจากพื้นที่นี้เมื่อยังไม่ได้บันทึกรายชื่อเมือง เบอร์โทร อีเมล และเว็บไซต์ด้านบนคือข้อมูลที่พิมพ์บนรายงานและใช้สร้างลิงก์สาธารณะของสำนักงาน',
  fc_market_region: 'เมือง / พื้นที่',
  fc_market_region_hint: 'เว้นว่าง = ไม่ระบุสถานที่',
  fc_lead_sites: 'เว็บไซต์อื่นที่ส่งลูกค้าเป้าหมาย',
  fc_lead_sites_hint: 'แบบฟอร์มติดต่อบนเว็บไซต์เหล่านี้ (และเว็บไซต์ด้านบน) จะบันทึกคำถามเป็นลูกค้าเป้าหมายของสำนักงานนี้ คั่นด้วยจุลภาค เช่น example.com',
  fc_cities_title: 'เมืองของ AI Marketing',
  fc_cities_hint: 'เมืองที่ AI Marketing ค้นหาลูกค้า ตามลำดับ — เมืองแรกคือค่าเริ่มต้น ค้นทีละย่าน เมืองที่ไม่มีย่านจะค้นทั้งเมือง',
  fc_cities_from_firms: 'ยังไม่ได้บันทึกรายชื่อ — ใช้พื้นที่ตลาดของสำนักงาน: {{cities}}',
  fc_cities_none: 'ยังไม่ได้บันทึกรายชื่อ และยังไม่มีสำนักงานใดระบุพื้นที่ตลาด — AI Marketing ยังไม่มีเมืองให้ค้นหา',
  fc_city_default: 'เมือง (ค่าเริ่มต้น)',
  fc_city: 'เมือง',
  fc_city_areas: 'ย่าน (บรรทัดละหนึ่ง)',
  fc_city_areas_ph: 'เว้นว่าง = ทั้งเมือง',
  fc_city_add: 'เพิ่มเมือง',
  fc_am_subtitle: 'ทำเนียบธุรกิจ{{country}} ({{cities}}) — ค้นพบโดย AI และแก้ไขได้',
  fc_am_subtitle_nocountry: 'ทำเนียบธุรกิจ ({{cities}}) — ค้นพบโดย AI และแก้ไขได้',
  fc_social_unset: 'การติดตั้งนี้ยังไม่ได้ตั้งที่อยู่ของ Social Poster — กำหนดได้ที่ REACT_APP_SOCIAL_POSTER_URL ในการตั้งค่าบิลด์ (.env.production)',
};
